import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const DebtRepaymentToMonthlyBankRevenueRatioProcessPayloadSchema = z.object({
    ratio: z.number().optional(),
    avarageDebtRepayment: z.number().optional(),
    averageBankRevenue: z.number().optional(),
});

export class DebtRepaymentToMonthlyBankRevenueRatioProcessPayload extends FromSchema(
    DebtRepaymentToMonthlyBankRevenueRatioProcessPayloadSchema,
) {
    ratio?: number;
    avarageDebtRepayment?: number;
    averageBankRevenue?: number;
}
